import React from "react";
import { useEffect, useState } from "react";
import { useParams } from 'react-router';
import { useTranslation } from "react-i18next";
import i18next from 'i18next';
import exportFromJSON from 'export-from-json';
import * as XLSX from 'xlsx';
import { Row, Col, Button, Flex, notification,} from 'antd';
import { Text } from '../../../../Atomics/Text';
import { SelectAtomic } from "../../../../Atomics/SelectAtomic";
import Spinner from "../../../../Atomics/Spinner";
import useFetch from "../../../../../../server/useFetch";
import query from "../../../../../../server/constants.api";
import logger from "../../../../../../server/server";


export const BuildingExportRawData = ({ selectPotencyTypeRaw, filterPeriod, pickerPlaceHolder, fileTitle, hideField }) => {
  const { t } = useTranslation();
  const { id } = useParams();
  const [api, contextHolder] = notification.useNotification();
  const { checkToken } = true;

  const [selectPotency, setSelectPotency] = useState(null);

  function handleSelectPotency(value) {
    setSelectPotency(value)
  }

  //Export Button
  const [exportData, setExportData] = useState(null);
  const [isToExportData, setIsToExportData] = useState(false);
  const handleExportButton = () => {
    let data = {
      startDate: filterPeriod.startPeriod,
      endDate: filterPeriod.endPeriod,
      powerType: selectPotency
    }
    checkToken();//Validate token
    setExportData(data);
    setIsToExportData(true);
  }

  const { data: rawData, isLoading: rawDataIsLoading, refetch: refetchRawData } =
    useFetch(query.path.exportRawData, 'getExportRawData', { id: id, filters: JSON.stringify(exportData), language: i18next.resolvedLanguage }, isToExportData);

  useEffect(() => {
      try {
        if (rawData?.data.length > 0) {

          //CSV
          exportFromJSON({
            data: rawData?.data,
            fileName: fileTitle,
            exportType: 'csv',
          })
          // logger.info('User downloaded raw data!');

          //XLSX
          // Create a new workbook
          const wb = XLSX.utils.book_new();

          // Iterate over each object in the data array
          rawData?.data.forEach((item, index) => {
            // Create a worksheet for each object
            const ws = XLSX.utils.json_to_sheet(item[Object.keys(item)[0]]);

            // Add the worksheet to the workbook
            XLSX.utils.book_append_sheet(wb, ws, `Sheet${index + 1}`);
          });

          // Save the workbook as an Excel file
          XLSX.writeFile(wb, fileTitle + '.xlsx');
        } else {
          api.info({
            message: t('info'),
            description: t('infoDescription'),
            placement: 'topRight',
            duration: 5,
          });
        }
      }
      catch (error) {
        // logger.error('Error in download raw data');
        console.error('(Register detail page): Errordownload raw data error: ', error);
      }
      finally {
        setIsToExportData(false);
      }
  }, [rawData, rawDataIsLoading])

  return (
    <Flex id='Export' className='ant-anchors-content-item' gap={32} vertical="true">
      <Text $fontColor='coolgray-12' $fontSize='text_xl' $weight='regular' $marginRight='s03'>{t('Export')}</Text>
      <Row align='middle' gutter={[16, 16]}>
        {hideField ?
          <Col span={20}>
            <Text $fontColor='coolgray-12' $fontSize='text_md' $weight='regular' $marginRight='s03'>{t('It is not possible to export data for annual period')}</Text>
          </Col>
          :
          <Col span={5}>
            <SelectAtomic
              optionsData={selectPotencyTypeRaw}
              handleOptionsChange={handleSelectPotency}
              fullWidth={true}

            />

          </Col>
        }
        {hideField ? null :
          <Col span={15}>
            <Flex horizontal='true'>
              <Text $fontColor='coolgray-12' $fontSize='text_md' $weight='regular' $marginRight='s03'>{t('Exportation for the selected period ')}</Text>
              <Text $fontColor='coolgray-12' $fontSize='text_md' $weight='medium' $marginRight='s03'>{pickerPlaceHolder}</Text>
            </Flex>
          </Col>
        }
        {isToExportData ?
          <Col span={2} offset={2}>
            <Spinner stroke="green" size='30px' />
          </Col>
          :
          <Col span={4}>
            <Flex justify="flex-end">
              <Button disabled={!hideField && selectPotency ? false : true} shape="round" className="ant-btn ant-btn-blue -medium" onClick={handleExportButton}>{t('exportRawData')}</Button>
            </Flex>
          </Col>
        }

      </Row>
    </Flex>
  )
}